/**
 * Flames Army — Wishlist
 * Paso 6: eventos a Klaviyo.
 *
 * Escucha los cambios de la wishlist y los manda a Klaviyo como eventos
 * personalizados. Debe cargarse DESPUÉS de wishlist.js.
 *
 * Klaviyo solo registra actividad de navegadores identificados. Si la
 * persona nunca hizo clic en un email ni se suscribió, el evento se
 * descarta — salvo que tengas activado el backfill de visitantes
 * anónimos, en cuyo caso queda guardado y se envía cuando se identifique.
 */

(function () {
  'use strict';

  if (!window.Wishlist) return;

  var EVENT_ADDED = 'Added to Wishlist';
  var EVENT_REMOVED = 'Removed from Wishlist';

  // klaviyo.js carga de forma asíncrona: guardamos lo que pase antes.
  var queue = [];
  var attempts = 0;
  var MAX_ATTEMPTS = 20; // ~10 segundos
  var timer = null;

  function klaviyoReady() {
    return window.klaviyo && typeof window.klaviyo.track === 'function';
  }

  function send(name, properties) {
    try {
      var result = window.klaviyo.track(name, properties);
      if (result && typeof result.catch === 'function') {
        result.catch(function () {});
      }
    } catch (e) {
      // Un evento perdido no debe romper nada del sitio.
    }
  }

  function flush() {
    while (queue.length) {
      var job = queue.shift();
      send(job.name, job.properties);
    }
  }

  function track(name, properties) {
    if (klaviyoReady()) {
      send(name, properties);
      return;
    }

    queue.push({ name: name, properties: properties });
    waitForKlaviyo();
  }

  function waitForKlaviyo() {
    if (timer) return;

    timer = setInterval(function () {
      attempts++;

      if (klaviyoReady()) {
        clearInterval(timer);
        timer = null;
        flush();
        return;
      }

      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(timer);
        timer = null;
        queue.length = 0;
      }
    }, 500);
  }

  /* ------------------------------------------------------------------
   * Propiedades del evento
   * ------------------------------------------------------------------ */

  function buildProperties(item, count) {
    var properties = {
      ProductID: item.id,
      WishlistCount: count
    };

    if (item.variantId) properties.VariantID = item.variantId;

    if (item.handle) {
      properties.Handle = item.handle;
      properties.URL = window.location.origin + '/products/' + item.handle;
    }

    return properties;
  }

  // Link a la wishlist completa: sirve para el botón del email.
  function buildWishlistUrl() {
    var handles = [];
    var items = window.Wishlist.get();

    for (var i = 0; i < items.length; i++) {
      if (items[i].handle) handles.push(items[i].handle);
    }

    if (handles.length === 0) return null;
    return window.location.origin + '/pages/wishlist?w=' + handles.join(',');
  }

  /* ------------------------------------------------------------------
   * Escucha
   * ------------------------------------------------------------------ */

  document.addEventListener(window.Wishlist.EVENT, function (event) {
    var detail = event.detail || {};

    // 'sync' llega desde otra pestaña y 'merge' desde un link compartido:
    // ninguno es una acción deliberada de esta persona acá.
    if (detail.action !== 'add' && detail.action !== 'remove') return;
    if (!detail.item) return;

    var properties = buildProperties(detail.item, detail.count);
    var wishlistUrl = buildWishlistUrl();

    if (wishlistUrl) properties.WishlistURL = wishlistUrl;

    track(detail.action === 'add' ? EVENT_ADDED : EVENT_REMOVED, properties);
  });
})();